import { date } from "../lib";

const options = { dateStyle: 'medium', timeStyle: 'short'};

export const formatIsoDate = (dateString, locale) => {
  const formatted = date.parseISODate(dateString);
  return formatted ? formatted.toLocaleString(locale, options) : null;
};